'use client'

import { useState } from 'react'
import { Button } from '@/components/ui/button'
import { Plus } from 'lucide-react'

import { CreditItem } from './CreditItemsTable'
import { AddMonthDialog } from './add-month'
import { MonthlyRow } from './monthly'
export interface MonthlyCredit {
  id: string
  month: string
  totalUsed: number
  items: CreditItem[]
  files: File[]
  isPaid?: boolean
  isSituacaoPerDComp?: boolean
}

interface CreditControlTabProps {
  data: MonthlyCredit[]
  setData: (data: MonthlyCredit[]) => void
  title: string
}

export function CreditControlTab({ data, setData, title }: CreditControlTabProps) {
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false)

  const addMonth = (month: string) => {
    const newMonth: MonthlyCredit = {
      id: Date.now().toString(),
      month,
      totalUsed: 0,
      items: [],
      files: []
    }
    setData([...data, newMonth])
  }

  const updateMonth = (monthId: string, updatedMonth: MonthlyCredit) => {
    setData(data.map(month => (month.id === monthId ? updatedMonth : month)))
  }

  const deleteMonth = (monthId: string) => {
    setData(data.filter(month => month.id !== monthId))
  }

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h3 className="text-lg font-semibold">{title}</h3>
        <Button onClick={() => setIsAddDialogOpen(true)} size="sm">
          <Plus className="w-4 h-4 mr-2" />
          Adicionar Mês
        </Button>
      </div>

      <div className="space-y-0">
        {data.length === 0 ? (
          <div className="text-center py-8 text-muted-foreground">Nenhum mês de competência adicionado ainda.</div>
        ) : (
          <>
            <div className="grid grid-cols-12  px-4 py-3 border-b font-medium text-sm text-muted-foreground">
              <div className="col-span-1">Expan</div>
              <div className="col-span-2">Competência</div>
              <div className="col-span-2">Total Utilizado</div>
              <div className="col-span-2">Situação PER/DComp</div>
              <div className="col-span-1">Pago</div>
              <div className="col-span-4">Ações</div>
            </div>

            {data
              .sort((a, b) => {
                // Converte strings de mês/ano para Date para comparação correta
                const dateA = new Date(a.month + '-01')
                const dateB = new Date(b.month + '-01')
                return dateB.getTime() - dateA.getTime()
              })
              .map(monthData => (
                <MonthlyRow
                  key={monthData.id}
                  monthData={monthData}
                  onUpdate={updatedMonth => updateMonth(monthData.id, updatedMonth)}
                  onDelete={() => deleteMonth(monthData.id)}
                />
              ))}
          </>
        )}
      </div>

      <AddMonthDialog isOpen={isAddDialogOpen} onClose={() => setIsAddDialogOpen(false)} onAdd={addMonth} />
    </div>
  )
}
